import React, { PropsWithChildren } from 'react';
import type { BankAccountFormatRuleRes } from '@dealstack/shared/lib/generated';
import { BankAccountVerificationContext } from './BankAccountVerificationContext.tsx';
import { useBankAccountVerification } from './useBankAccountVerification.ts';
import type { BankAccountVerifyFn } from './useBankAccountForm.types.ts';

interface Props {
	rule: BankAccountFormatRuleRes | null;
	verifyIdentifiers?: BankAccountVerifyFn;
}

export const BankAccountVerificationScope = ({
	rule,
	verifyIdentifiers,
	children,
}: PropsWithChildren<Props>) => {
	const verification = useBankAccountVerification({ rule, verifyIdentifiers });

	return (
		<BankAccountVerificationContext.Provider value={verification}>
			{children}
		</BankAccountVerificationContext.Provider>
	);
};
